export default interface UiCustomization {
    commodityBalancesQuantityDecimalPrecision: number;
    addEditOfferContractQuantityDecimalPrecision: number;
    offerContractDetailsQuantityDecimalPrecision: number;
    offersContractsQuantityDecimalPrecision: number;
    activityReportQuantityDecimalPrecision: number;
    notificationsQuantityDecimalPrecision: number;
}

export const defaultUiCustomization: UiCustomization = {
    commodityBalancesQuantityDecimalPrecision: 2,
    addEditOfferContractQuantityDecimalPrecision: 2,
    offerContractDetailsQuantityDecimalPrecision: 2,
    offersContractsQuantityDecimalPrecision: 2,
    activityReportQuantityDecimalPrecision: 2,
    notificationsQuantityDecimalPrecision: 2,
};